import classNames from "classnames";

import { CCard, CCardBody } from "@coreui/react";

import { format } from "src/utils/dayjs";

import { ImagesList } from "../ImagesList";

export const MarkInfo = ({ watch }) => {
  return (
    <div className="grid grid-cols-4 gap-2 text-base mb-2">
      <div className="col-span-1 h-auto">
        <CCard className="h-full mb-0">
          <CCardBody>
            <div className="flex flex-col gap-3">
              <p className="font-medium mb-0">
                Ngày đánh giá gần nhất:&nbsp;
                <span className="font-normal">
                  {format(watch("latest_date"))}
                </span>
              </p>
              <p className="font-medium mb-0">
                Trạng thái:&nbsp;
                <span
                  className={classNames(
                    "font-bold",
                    watch("status") === "Hoàn thành"
                      ? "text-[#02782a]"
                      : "text-[#bd9d3c]"
                  )}
                >
                  {watch("status")}
                </span>
              </p>
            </div>
          </CCardBody>
        </CCard>
      </div>

      <div className="col-span-3">
        <CCard className="h-full mb-0">
          <CCardBody>
            <div className="flex flex-col gap-3">
              <div>
                <p className="font-medium mb-0">Danh sách NVL cung cấp:</p>
                <p className="whitespace-pre-wrap mb-0">
                  {watch("materials")
                    ?.map((e) => e?.name)
                    ?.join(", ")}
                </p>
              </div>
              <div>
                <p className="font-medium mb-0">Tài liệu minh chứng:</p>
                <ImagesList list={watch("files")} />
              </div>
            </div>
          </CCardBody>
        </CCard>
      </div>
    </div>
  );
};
